module.exports = __webpack_public_path__ + "img/foot@2x.718cd0cb.png";